import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import {
  CancelDraftAppointmentDocument,
  DraftAppointmentCancellationReason,
} from '~/graphql/generated/graphql';
import { draftAppointmentPatientProfileDrawerState } from '~/state/reception/atoms';

export const useCancelDraftAppointment = (draftAppointmentId: string) => {
  const [cancel, { loading }] = useMutation(CancelDraftAppointmentDocument);
  const setState = useSetAtom(draftAppointmentPatientProfileDrawerState);

  const handleCancel = useCallback(
    async (reason: DraftAppointmentCancellationReason) => {
      try {
        await cancel({
          variables: {
            input: {
              draftAppointmentId,
              reason,
            },
          },
        });
      } catch (_error) {
        setState((_state) => ({
          ..._state,
          error: _error?.message || 'エラーが発生しました',
        }));
      }
    },
    [draftAppointmentId, cancel, setState],
  );

  return {
    isLoading: loading,
    handleCancel,
  };
};
